import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./providers/auth-provider";
import { AppRouter } from "./router/app-router";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
